import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default (WrappedComponent) => {

  return class extends Component {

    componentDidMount() {
      const el = ReactDOM.findDOMNode(this);
      const height = el.offsetHeight;
      el.style.height = `${height}px`;
    }

    render() {
      return <WrappedComponent {...this.props}/>
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/FixedHeight.js